import React, { useState, useEffect } from 'react';
import PurchaseOrderService from '../../services/PurchaseOrderService/PurchaseOrderService';
import GearSpinner from '../GearSpinner/GearSpinner';
import './Modal.css';

const ProductInventoryModal = ({ isShow, productNumber, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [inventoryData, setInventoryData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (isShow && productNumber) {
            setLoading(true);
            setErrorMessage('');
            const purchaseOrderService = new PurchaseOrderService();
            purchaseOrderService.getProductInventory(productNumber)
                .then((response) => {
                    const data = response?.data;
                    if (data && data.status === 'success') {
                        setInventoryData(data.result || []);
                    } else {
                        setErrorMessage(data?.message || 'Failed to load inventory.');
                        setInventoryData([]);
                    }
                })
                .catch((err) => {
                    console.error('Error fetching inventory:', err);
                    setErrorMessage('Failed to fetch inventory.');
                    setInventoryData([]);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setInventoryData([]);
            setErrorMessage('');
            setLoading(false);
        }
    }, [isShow, productNumber]);

    if (!isShow) return null;

    // Calculate total stock across all locations
    const totalStock = Array.isArray(inventoryData)
        ? inventoryData.reduce((acc, curr) => acc + (Number(curr.count) || 0), 0)
        : 0;

    return (
        <div className="motor-modal-overlay">
            <div className="motor-modal-content" style={{ maxWidth: '600px', width: '90%', padding: 0 }}>
                {/* Modal Header */}
                <div className="modal-header-dark">
                    <h4 className="m-0">
                        Product Inventory
                    </h4>
                    <button
                        type="button"
                        className="btn-close btn-close-white"
                        onClick={onClose}
                        aria-label="Close"
                    ></button>
                </div>

                {/* Modal Body */}
                <div className="modal-body-content" style={{ padding: '20px', minHeight: '150px' }}>
                    {/* Subtitle / Product Number */}
                    <div className="mb-3">
                        <span className="fw-semibold text-secondary">Product Number: </span>
                        <span className="fw-bold" style={{ color: '#bb5d40' }}>{productNumber}</span>
                    </div>

                    {loading ? (
                        <div className="d-flex flex-column align-items-center justify-content-center py-5 gap-2">
                            <GearSpinner />
                            <span className="text-muted small">Loading inventory data...</span>
                        </div>
                    ) : errorMessage ? (
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-bordered align-middle text-center mb-0">
                                <thead style={{ backgroundColor: '#313131', color: '#fff', borderBottom: '4px solid #bb5d40' }}>
                                    <tr>
                                        <th style={{ color: '#fff' }}>Location</th>
                                        <th style={{ color: '#fff' }}>Available Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {inventoryData && inventoryData.length > 0 ? (
                                        <>
                                            {inventoryData.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td className="fw-semibold text-start px-3">{item.location}</td>
                                                    <td>
                                                        <span className={`badge ${Number(item.count) > 0 ? 'bg-success' : 'bg-secondary'}`} style={{ fontSize: '0.9rem', padding: '6px 12px' }}>
                                                            {item.count}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr style={{ backgroundColor: '#f8f9fa' }}>
                                                <td className="fw-bold text-start px-3">Total Stock</td>
                                                <td className="fw-bold">
                                                    <span className={`badge ${totalStock > 0 ? 'bg-primary' : 'bg-secondary'}`} style={{ fontSize: '0.95rem', padding: '6px 12px' }}>
                                                        {totalStock}
                                                    </span>
                                                </td>
                                            </tr>
                                        </>
                                    ) : (
                                        <tr>
                                            <td colSpan="2" className="text-muted py-4">
                                                No inventory details found for this product.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                {/* Modal Footer */}
                <div className="modal-footer-dark">
                    <button type="button" className="btn btn-secondary px-4" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductInventoryModal;
